import { deriveChatBusy } from './turnLifecycle';

interface ProjectReplyChromeGateArgs {
  isInitialLoading: boolean;
  isEmpty: boolean;
  turnInFlight: boolean;
  isSubmitting: boolean;
  runFailed: boolean;
  runClosed: boolean;
  hasPendingApproval: boolean;
  latestTurnHasReply: boolean;
  /** A recovered terminal failure can still receive feedback. */
  latestTurnIsFailed?: boolean;
  latestTurnFailureReason?: string | null;
  hasQueuedTurns?: boolean;
  /** Hide follow-up chips (Clinician remaining <= 0). */
  hideFollowUpQuestions?: boolean;
}

const isTurnSettled = (args: ProjectReplyChromeGateArgs): boolean =>
  !args.isInitialLoading &&
  !args.isEmpty &&
  !deriveChatBusy(args) &&
  !args.runFailed &&
  !args.runClosed &&
  !args.hasPendingApproval;

export const shouldShowProjectReplyFeedback = (
  args: ProjectReplyChromeGateArgs
): boolean =>
  isTurnSettled(args) && (args.latestTurnHasReply || args.latestTurnIsFailed === true);

export const shouldShowProjectFollowUpQuestions = (
  args: ProjectReplyChromeGateArgs
): boolean =>
  isTurnSettled(args) &&
  (args.latestTurnHasReply ||
    (args.latestTurnIsFailed === true &&
      args.latestTurnFailureReason === 'consecutive_tool_failure_limit')) &&
  args.hideFollowUpQuestions !== true;
